import { defineStore } from 'pinia';

export interface Option {
  confirmColor: string;
  confirmText: string;
  width: number;
  noCancel: boolean;
}

type Resolve = (value: boolean) => void;
type Reject = (value: boolean) => void;

const defaultOption: Option = {
  confirmColor: 'primary',
  confirmText: 'OK',
  width: 550,
  noCancel: false,
};

export const useResourcesDialogStore = defineStore('resourcesDialog', {
  state: () => ({
    dialog: false,
    title: '',
    message: '',
    resources: {} as ResourceList,
    resolve: <Resolve>{},
    reject: <Reject>{},
    option: defaultOption,
  }),

  actions: {
    open(params: {
      title: string;
      message?: string;
      resources: ResourceList;
      option?: Partial<Option>;
    }): Promise<boolean> {
      if (params.option) {
        this.option = { ...defaultOption, ...params.option };
      } else {
        this.option = defaultOption;
      }

      this.title = params.title;
      this.message = params.message || '';
      this.resources = params.resources;
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    agree() {
      this.resolve(true);
      this.dialog = false;
    },

    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
});
